import React from 'react'
import { useTranslation } from 'react-i18next'
import { Combobox } from '@node-space/ui-components'
import useFilterTag from 'components/FilterBar/hooks/useFilterTag'
import { PaymentTag } from 'types/payments'

interface FilterTagProps {
  onPaymentTagChange: (value: string) => void
}

const FilterTag = ({ onPaymentTagChange }: FilterTagProps) => {
  const { t } = useTranslation()

  const { tag } = useFilterTag()

  const paymentTagOptions = [
    { value: PaymentTag.ALL, leftText: t(PaymentTag.ALL.toLowerCase()) },
    { value: t(PaymentTag.ONHOLD.toLowerCase()), leftText: t(PaymentTag.ONHOLD.toLowerCase()) },
  ]

  const onTagChange = (value: string) => {
    if (onPaymentTagChange && typeof onPaymentTagChange === 'function') {
      onPaymentTagChange(value)
    }
  }

  return (
    <Combobox
      id="tag"
      label={t('tag')}
      data-testid="filter-tag-field"
      defaultValue={tag}
      items={paymentTagOptions}
      onChange={value => onTagChange(value)}
    />
  )
}

export default FilterTag
